{% block verign_dv_accessibility_sw_purchase_button %}
    <mt-button @click="openPurchaseModal">
        {{ $tc('verignDvAccessibility.entityPurchaseButton') }}
    </mt-button>
{% endblock %}